import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full py-2 bg-mcgard-gray-400 px-5 md:px"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "mx-2 text-sm text-mcgard-gray-900"
}

import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useThemeStore } from '@/stores/useThemeStore';
import { useConfiguratorStore } from '@/stores/useConfiguratorStore';
import { BreadcrumbItem } from '@/utils/types/breadcrumb';


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const themeStore = useThemeStore();
const { filteredBreadcrumb } = storeToRefs(themeStore);
const configuratorStore = useConfiguratorStore();
const route = useRoute();
const router = useRouter();

function toDestination (item: BreadcrumbItem, index: number) {
  if (index === filteredBreadcrumb.value.length - 1) {
    return;
  }
  if (item.link) {
    router.push({
      name: item.link,
      query: item.query || {},
      params: item.params || {},
    });
  } else if (item.isSearchByKbaNumber) {
    configuratorStore.setIsSearchByKbaNumber(true);
    if (route.name !== 'configurator') {
      router.push({
        name: 'configurator',
        query: item.query || {},
        params: item.params || {},
      });
    }
  } else if (item.configuratorStep) {
    configuratorStore.setIsSearchByKbaNumber(false);
    configuratorStore.setStep(item.configuratorStep);
    if (route.name !== 'configurator') {
      router.push({ name: 'configurator' });
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(filteredBreadcrumb).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBreadcrumb), (item, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: `breadcrumb${index}`,
            class: _normalizeClass([
        'text-xs uppercase',
        index < _unref(filteredBreadcrumb).length - 1 ? 'text-mcgard-gray-900' : 'text-mcgard-primary'
      ])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass([
          index < _unref(filteredBreadcrumb).length - 1 ? 'cursor-pointer hover:font-semibold' : null
        ]),
              onClick: ($event: any) => (toDestination(item, index))
            }, _toDisplayString(_ctx.$t(item.label)), 11, _hoisted_2),
            (index < _unref(filteredBreadcrumb).length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " > "))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})